module.exports = __webpack_public_path__ + "img/h_s2e1_gallery_4.24a1031d.png";